import CountUp from 'react-countup';
import { Globe, Link2, ShieldAlert, Tags } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import type { CategorySummary } from './types';

type Kpi = { title: string; icon: LucideIcon; tone?: string; value: number | string };

export const CategoryKpis = ({ summary }: { summary: CategorySummary }) => {
  const { t } = useTranslation();
  const top = summary.categories.find((c) => c.id !== 'uncategorized');

  const kpis: Kpi[] = [
    { title: t('dnsCategories.kpi.requests'), icon: Globe, value: summary.totals.requests },
    { title: t('dnsCategories.kpi.blocked'), icon: ShieldAlert, tone: 'danger', value: summary.totals.blocked },
    { title: t('dnsCategories.kpi.domains'), icon: Link2, value: summary.totals.uniqueDomains },
    { title: t('dnsCategories.kpi.top'), icon: Tags, tone: 'warn', value: top ? top.name : t('dnsCategories.kpi.none') },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4">
      {kpis.map((kpi) => {
        const Icon = kpi.icon;
        return (
          <div key={kpi.title} className={`bd-card bd-kpi ${kpi.tone || ''}`}>
            <span className="bd-kpi-icon">
              <Icon size={18} strokeWidth={1.75} />
            </span>
            <div className="bd-kpi-text">
              <span className="bd-kpi-label" title={kpi.title}>{kpi.title}</span>
              {typeof kpi.value === 'number' ? (
                <CountUp className="bd-stat-num bd-kpi-num" preserveValue={true} end={kpi.value} duration={1.5} separator="," />
              ) : (
                <span className="bd-stat-num bd-kpi-num dc-kpi-text" title={kpi.value}>{kpi.value}</span>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};
